import { useEffect, useState } from 'react';

import PaginationPageButton from './PaginationPageButton';
import styles from './styles.module.scss';
import Button from '../../Buttons/Button';
import Row from '../../Blocks/Row';

function TablePagination({ num = 50, show = 1, onChange = () => { }, maxShow = 4, ...props }) {
  const [page, changePage] = useState(show - 1);

  const start = page < maxShow ? 0 : page - 2;

  const onClickPage = new_page => {
    changePage(new_page);
    onChange(new_page + 1);
  };

  useEffect(() => {
    changePage(show - 1);
  }, [show]);

  return num !== 1 ? (
    <>
      <Row style={{ marginTop: '25px', ...props.style }} styles={props.styles}>
        <Button className={styles.to_left} onClick={() => onClickPage(page === 0 ? 0 : num === 1 ? 0 : page - 1)} />
        {page >= num - 2 && num > maxShow + 1 && (
          <PaginationPageButton isShow={true} onClick={() => onClickPage(0)}>
            ...
          </PaginationPageButton>
        )}
        {[...Array(num)].map((e, key) => (
          <PaginationPageButton
            key={key}
            isShow={
              (key >= start && key < start + maxShow) || (page === num - 1 && key >= start - 1 && key < start + maxShow)
            }
            isActive={key === page}
            onClick={() => onClickPage(key)}
          >
            {key + 1}
          </PaginationPageButton>
        ))}
        {page < num - 2 && num > maxShow && (
          <PaginationPageButton isShow={true} onClick={() => onClickPage(num - 1)}>
            ...
          </PaginationPageButton>
        )}

        <Button
          className={styles.to_right}
          onClick={() => onClickPage(page + 1 === num ? page : num === 1 ? 0 : page + 1)}
        />
      </Row>
    </>
  ) : (
    <div />
  );
}

export default TablePagination;
